import React, { useState, useContext } from 'react';
import { ThemeContext } from '../theme';
import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import KeywordInputField from '../components/KeywordInputField';
import Button from '../components/Button';

const ILLUS_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961697/onboarding_image_2_z4l5e9.webp';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

const AGE_OPTIONS    = ['2-5', '6-10', '11-16'];
const GENDER_OPTIONS = ['Boy', 'Girl', 'Non-binary', 'Prefer not to say'];

export default function ChildProfileScreen({ onSkip, onCreate }) {
  const theme = useContext(ThemeContext);
  const [profileName, setProfileName] = useState('');
  const [age,         setAge]         = useState('');
  const [gender,      setGender]      = useState('');
  const [interests,   setInterests]   = useState(['Football', 'Cooking', 'Art', 'Reading']);

  return (
    <div style={{ flex: 1, alignSelf: 'stretch', display: 'flex', backgroundColor: theme.bgPrimary }}>
      <style>{`
        @keyframes onboardImgScaleOut {
          from { transform: scale(1.2); }
          to   { transform: scale(1); }
        }
      `}</style>

      {/* Left panel — illustration */}
      <div style={{ width: '38%', flexShrink: 0, position: 'relative', overflow: 'hidden', backgroundColor: theme.cardBg100 }}>
        <img
          src={ILLUS_URL}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', animation: 'onboardImgScaleOut 0.6s ease-out both' }}
        />
      </div>

      {/* Right panel — same padding as other auth screens */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 104px',
          overflowY: 'auto',
          backgroundColor: theme.cardBg,
        }}
      >
        {/* Outer column: gap 80×0.75=60px between content and buttons */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: s(80) }}>

          {/* Top section */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: s(48) }}>

            {/* Header */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: s(8) }}>
              <h1
                className="font-bogart"
                style={{ fontSize: s(36), fontWeight: 700, lineHeight: `${s(44)}px`, color: theme.text100, margin: 0 }}
              >
                Want to create<br />a tailored profile for<br />your child?
              </h1>
              <p
                className="font-satoshi"
                style={{ margin: 0, fontSize: s(18), lineHeight: `${s(24)}px`, color: theme.btnPrimaryBg }}
              >
                Step 2/2
              </p>
            </div>

            {/* Fields */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: s(16) }}>

              {/* Profile Name — full width */}
              <InputField
                label="Profile Name"
                required
                type="text"
                placeholder="Kiraz"
                value={profileName}
                onChange={e => setProfileName(e.target.value)}
                scale={SCALE}
              />

              {/* Age + Gender — side by side */}
              <div style={{ display: 'flex', gap: s(16) }}>
                <div style={{ flex: 1 }}>
                  <SelectField
                    label="Age"
                    options={AGE_OPTIONS}
                    value={age || 'Select age'}
                    onChange={setAge}
                    scale={SCALE}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <SelectField
                    label="Gender"
                    options={GENDER_OPTIONS}
                    value={gender || 'Select gender'}
                    onChange={setGender}
                    scale={SCALE}
                  />
                </div>
              </div>

              {/* Interests — keyword chip input */}
              <KeywordInputField
                label="Interests"
                tags={interests}
                onChange={setInterests}
                scale={SCALE}
              />

            </div>
          </div>

          {/* Buttons — Skip + Create */}
          <div style={{ display: 'flex', gap: s(20) }}>
            <Button
              variant="tertiary"
              onClick={onSkip}
              scale={SCALE}
              style={{ flex: 1 }}
            >
              Skip
            </Button>
            <button
              onClick={onCreate}
              className="font-satoshi font-bold"
              style={{
                flex: 1,
                padding: `${s(20)}px`,
                borderRadius: s(20),
                border: 'none',
                backgroundColor: theme.btnPrimaryBg,
                color: theme.btnPrimaryText,
                fontSize: s(18),
                lineHeight: `${s(24)}px`,
                cursor: 'pointer',
                transition: 'background-color 0.15s',
              }}
            >
              Create
            </button>
          </div>

        </div>
      </div>

    </div>
  );
}
